import { flattenNestedObject } from "../../../../../core/utils/utilFunctions";
import type { SiteDto } from "../../types/SiteDto";
import type { SiteEntity } from "../../types/SiteEntity";

// TODO Duplicated code: extract dynamic props validation and refactor code (all uses)
export const SiteDtoToEntity = ({ dynamicProperties, terminalParameters, ...rest }: Readonly<SiteDto>): SiteEntity => {
    const propValues = dynamicProperties?.dynamicPropertyValues?.map((propValue) => {
        const value = propValue.type === "CHECKBOX" ? propValue.value === "true" : propValue.value;

        return {
            id: propValue.id,
            key: propValue.key,
            type: propValue.type,
            label: propValue.label,
            pattern: propValue.pattern || "",
            readOnly: propValue.readOnly || false,
            value,
        };
    });

    const flattenedTerminalParameters = flattenNestedObject(terminalParameters, "terminalParameters");

    return {
        ...rest,
        ...flattenedTerminalParameters,
        dynamicProperties: {
            ...dynamicProperties,
            dynamicPropertyValues: propValues,
        },
        virtualSiteGroup: rest.virtualSiteGroup,
    };
};
